/* eslint-disable react/no-unused-state */
import { map, pick } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { Bubble } from 'react-chartjs-2';

import { getClubGenderPower6 } from '../../../../../utils/clubs';
import { ratingTypes } from '../../../../../utils/constants';
import { getClickAttrs, gtag } from '../../../../Analytics/gtag';

import styles from './power6Stats.scss';

const _ = { map, pick };

const hoverTealColor = '#d2db00';

class Power6Stats extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            clubId: null,
            schoolId: null,
            hoveredSchoolId: null,
            utrRegularFontFamily: '"Inter", Arial, sans-serif',
            utrNumeralsFontFamily: '"Big Shoulders", sans-serif',
            utrMediumGrayColor: '#bac6d6',
            utrLightMagentaColor: '#e0004f',
            utrLightTealColor: '#00C0F7',
        };

        this.setPower6ChartRef = this.setPower6ChartRef.bind(this);
        this.getPower6ChartData = this.getPower6ChartData.bind(this);
        this.getPower6Data = this.getPower6Data.bind(this);
        this.getPower6ChartOptions = this.getPower6ChartOptions.bind(this);
        this.getBackgroundColor = this.getBackgroundColor.bind(this);
        this.getBorderColor = this.getBorderColor.bind(this);
        this.getBorderWidth = this.getBorderWidth.bind(this);
        this.getDataLabelColor = this.getDataLabelColor.bind(this);
        this.getPower6ChartRatingsAxisLabels = this.getPower6ChartRatingsAxisLabels.bind(this);
        this.setPower6stats = this.setPower6stats.bind(this);

        this.setPower6stats(props);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        this.setPower6stats(newProps);
    }

    setPower6stats(newProps) {
        if (newProps.clubDetails && newProps.clubDetails.id && (this.state.clubId !== newProps.clubDetails.id)) {
            this.setState({
                clubId: newProps.clubDetails.id,
            });
            if (newProps.clubDetails && newProps.clubDetails.tierType && newProps.clubDetails.tierType.isCollege) {
                if (newProps.clubDetails.schoolProfile && newProps.clubDetails.schoolProfile.conferenceId) {
                    this.setState({
                        schoolId: newProps.clubDetails.schoolProfile.id,
                    });
                    const gender = getClubGenderPower6(newProps.clubDetails.clubSubType.id);
                    if (gender === 'm' || gender === 'f') {
                        console.log('p6 loaded from component');
                        this.props.getPower6Stats({
                            conferenceId: newProps.clubDetails.schoolProfile.conferenceId,
                            gender,
                        });
                    }
                }
            }
        }
    }

    setPower6ChartRef(node) {
        this.power6ChartRef = node;
    }

    getPower6ChartData() {
        const that = this;
        const resultsData = that.getPower6Data();
        const resultsDataPointsMapped = _.map(resultsData, val => _.pick(val, ['x', 'y', 'schoolId', 'descriptions', 'dataLabelColor']));
        const resultsDataPointBackgroundColor = _.map(resultsData, 'backgroundColor');
        const resultsDataBorderColor = _.map(resultsData, 'borderColor');
        const resultsDataBorderWidth = _.map(resultsData, 'borderWidth');
        return {
            labels: that.getPower6ChartRatingsAxisLabels(),
            datasets: [
                {
                    fill: false,
                    backgroundColor: resultsDataPointBackgroundColor,
                    aspectRatio: 1.0,
                    borderColor: resultsDataBorderColor,
                    borderWidth: resultsDataBorderWidth,
                    data: resultsDataPointsMapped,
                    datalabels: {
                        anchor: 'center',
                        align: 'center',
                        color: (context) => {
                            const value = context.dataset.data[context.dataIndex];
                            return value.dataLabelColor;
                        },
                        display: (context) => {
                            const value = context.dataset.data[context.dataIndex];
                            return value.count > 1;
                        },
                        font: context => ({
                            weight: 'bold',
                            family: that.state.utrRegularFontFamily,
                            size: (context.chart.width / 100),
                        }),
                        formatter: value => value.count,
                        offset: 2,
                        padding: 0,
                    },
                },
            ],
        };
    }

    getPower6Data() {
        const { power6Stats } = this.props;
        const resultsData = [];
        const { indexAndRatings } = power6Stats;
        for (let i = 0; i < indexAndRatings.length; i += 1) {
            resultsData.push({
                x: indexAndRatings[i].index,
                y: indexAndRatings[i].rating,
                schoolId: indexAndRatings[i].schoolId,
                descriptions: indexAndRatings[i].description,
                backgroundColor: this.getBackgroundColor(indexAndRatings[i]),
                borderColor: this.getBorderColor(indexAndRatings[i]),
                borderWidth: this.getBorderWidth(indexAndRatings[i]),
                dataLabelColor: this.getDataLabelColor(indexAndRatings[i]),
            });
        }
        return resultsData;
    }

    getBackgroundColor(indexAndRating) {
        if (indexAndRating.schoolId === this.state.schoolId) {
            return this.state.utrLightMagentaColor;
        }
        if (indexAndRating.schoolId !== this.state.schoolId && indexAndRating.schoolId === this.state.hoveredSchoolId) {
            return hoverTealColor;
        }
        return this.state.utrLightTealColor;
    }

    getBorderColor(indexAndRating) {
        if (indexAndRating.schoolId === this.state.schoolId) {
            return this.state.utrLightMagentaColor;
        }
        if (indexAndRating.schoolId !== this.state.schoolId && indexAndRating.schoolId === this.state.hoveredSchoolId) {
            return hoverTealColor;
        }
        return this.state.utrLightTealColor;
    }

    getBorderWidth() {
        return 1.0;
    }

    getDataLabelColor() {
        return this.state.utrMediumGrayColor;
    }

    getPower6ChartOptions() {
        const { power6Stats } = this.props;
        const that = this;
        return {
            elements: {
                point: {
                    radius: (context) => {
                        const value = context.dataset.data[context.dataIndex] || {};
                        const size = context.chart.width;
                        const base = value.count > 1 ? 0.2 : 0.1;
                        return (size / 24) * base;
                    },
                },
            },
            layout: {
                padding: {
                    left: 0,
                    right: 0,
                    top: 50,
                    bottom: 50,
                },
            },
            legend: {
                display: false,
            },
            maintainAspectRatio: false,
            responsive: true,
            tooltips: {
                enabled: true,
                callbacks: {
                    title: () => '',
                    label: (item, data) => data.datasets[item.datasetIndex].data[item.index].descriptions,
                },
                backgroundColor: '#fff',
                displayColors: false,
                titleFontColor: that.state.utrMediumGrayColor,
                titleFontFamily: that.state.utrRegularFontFamily,
                titleMarginBottom: 10,
                bodyFontColor: that.state.utrMediumGrayColor,
                bodyFontFamily: that.state.utrRegularFontFamily,
                bodySpacing: 10,
                xAlign: 'center',
                yAlign: 'bottom',
                xPadding: 16,
                yPadding: 16,
            },
            hover: {
                mode: null,
                onHover: (evt) => {
                    const item = this.power6ChartRef.chartInstance.getElementsAtEvent(evt);
                    if (item.length) {
                        // TODO: is this expected?
                        // eslint-disable-next-line
                        const data = this.getPower6ChartData().datasets[0].data[item[0]._index];
                        this.setState({ hoveredSchoolId: data.schoolId });
                    } else {
                        this.setState({ hoveredSchoolId: null });
                    }
                },
            },
            annotation: {
                annotations: [{
                    type: 'line',
                    mode: 'vertical',
                    scaleID: 'x-axis-0',
                    value: power6Stats.currentRating,
                    borderColor: that.state.utrLightTealColor,
                    borderWidth: 4,
                    drawTime: 'beforeDatasetsDraw',
                }, {
                    type: 'line',
                    mode: 'horizontal',
                    scaleID: 'y-axis-0',
                    value: '50',
                    borderColor: that.state.utrMediumGrayColor,
                    borderWidth: 1,
                    drawTime: 'beforeDatasetsDraw',
                }],
            },
            scales: {
                showScaleValues: true,
                yAxes: [{
                    display: true,
                    gridLines: {
                        display: true,
                        drawBorder: false,
                        drawOnChartArea: true,
                    },
                    scaleLabel: {
                        display: true,
                        labelString: `Singles ${ratingTypes.tennis}`,
                        fontSize: 12,
                        fontStyle: '400',
                        fontFamily: that.state.utrRegularFontFamily,
                    },
                    ticks: {
                        max: power6Stats.maxRatingForScale,
                        stepSize: power6Stats.stepSizeVerticalAxis,
                        min: power6Stats.minRatingForScale,
                        padding: 10,
                        fontSize: 12,
                        fontStyle: '400',
                        fontFamily: that.state.utrRegularFontFamily,
                        callback: (value) => {
                            if (value === 'NaN') {
                                return null;
                            }
                            const displayOnAxis = ['00', '50'];
                            const valueRounded = value.toFixed(2);
                            if (displayOnAxis.indexOf(valueRounded.split('.')[1]) > -1) {
                                return valueRounded;
                            }
                            return null;
                        },
                    },
                }],
                xAxes: [{
                    id: 'x-axis-0',
                    // type: 'linear',
                    display: true,
                    gridLines: {
                        display: false,
                        drawBorder: false,
                        drawOnChartArea: true,
                    },
                    scaleLabel: {
                        display: true,
                        labelString: `Lineup Position by ${ratingTypes.tennis}`,
                        fontSize: 12,
                        fontStyle: '400',
                        fontFamily: that.state.utrRegularFontFamily,
                    },
                    ticks: {
                        max: power6Stats.maxNonRatingScaleChartTicks,
                        stepSize: power6Stats.nonRatingScaleStepSize,
                        min: 1,
                        fontSize: 14,
                        fontStyle: '400',
                        fontFamily: that.state.utrRegularFontFamily,
                        autoSkip: false,
                        maxRotation: 0,
                        callback: (value) => {
                            const displayOnAxis = [10, 30, 50, 70, 90, 110];
                            const displayIndex = displayOnAxis.indexOf(value);
                            if (displayIndex !== -1) {
                                return `${displayIndex + 1}`;
                            }
                            return null;
                        },
                    },
                }],
            },
        };
    }

    getPower6ChartRatingsAxisLabels() {
        const { power6Stats } = this.props;
        const labels = [];
        for (let i = power6Stats.minRatingForScale; i <= power6Stats.maxRatingForScale; i += power6Stats.stepSizeVerticalAxis) {
            labels.push(i);
        }
        return labels;
    }

    render() {
        const {
            clubDetails,
            power6Stats,
            power6StatsState,
            'data-testid': dataTestId,
        } = this.props;

        return (
            <React.Fragment>
                <div className={`${styles.section}`} data-testid={dataTestId}>
                    {power6StatsState.loading && (
                        <React.Fragment>
                            Loading Power6 Stats
                        </React.Fragment>
                    )}
                    {!power6StatsState.loading && !power6StatsState.successful && (
                        <React.Fragment>
                            <div className={`${styles.unsuccessfulStatsRetrieval}`} data-testid={dataTestId && `${dataTestId}.error-message`}>
                                Unable to retrieve power6 stats
                            </div>
                        </React.Fragment>
                    )}
                    {!power6StatsState.loading && power6StatsState.successful && (
                        <React.Fragment>
                            <div className={`title mt16 mb0 text-uppercase`} data-testid={dataTestId && `${dataTestId}.title`}>
                                {ratingTypes.tennis} Lineup vs Conference
                            </div>
                            <div className={`${styles.legend}`}>
                                <div className={`${styles.school}`} data-testid={dataTestId && `${dataTestId}.school`}>
                                    <span className={`${styles.indicator}`} />
                                    {(clubDetails.schoolProfile.shortName || clubDetails.schoolProfile.displayName || clubDetails.schoolProfile.name)}
                                </div>
                                <div className={`${styles.conference}`} data-testid={dataTestId && `${dataTestId}.conference`}>
                                    <span className={`${styles.indicator}`} />
                                    {(clubDetails.schoolProfile.conferenceShortName || clubDetails.schoolProfile.conference)}
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                </div>
                <div className={`${styles.section} tab-bar pt0 pl0 pr0 pb0`}>
                    <div className={`${styles.chartContainer} d-block auto-scroll`}>
                        {power6Stats && (
                            <div
                                className={`${styles.chart}`}
                                onMouseOver={() => {
                                    gtag('hover', {
                                        category: 'Power6 Stats CTA',
                                        label: `Mouse over graph`,
                                    });
                                }}
                                onTouchEndCapture={() => {
                                    gtag('touch', {
                                        category: 'Power6 Stats CTA',
                                        label: `Touch graph`,
                                    });
                                }}
                                {...getClickAttrs({
                                    category: 'Power6',
                                    context: 'Power6 Stats graph',
                                    location: 'Power6 Stats CTA',
                                })}
                            >
                                <Bubble
                                    data={canvas => this.getPower6ChartData(canvas)}
                                    options={this.getPower6ChartOptions()}
                                    width={1200}
                                    height={440}
                                    ref={this.setPower6ChartRef}
                                />
                            </div>
                        )}
                        {!power6Stats && (
                            <div className="text-center mt48" data-testid={dataTestId && `${dataTestId}.no-data-message`}>
                                Not enough results to display the chart
                            </div>
                        )}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

Power6Stats.propTypes = {
    power6Stats: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Power6Stats;
